import { render, staticRenderFns } from "./BroadcastDetails.vue?vue&type=template&id=7d270ab2"
import script from "./BroadcastDetails.vue?vue&type=script&lang=js"
export * from "./BroadcastDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports